import {
  ExternalTitle,
  TriggerLine,
  MainHeader,
  CardRowMaterial,
  HeaderSubtitle,
  CardMaterial,
  BlankSpace,
  CarrouselMaterial,
  TitleCard,
  TitleCardPDF,
  Banner,
  TextCardMaterial,
  Text,
  Faq,
  FileManagerComponent,
  TextMaterial,
  ImagenContainerHome,
  ImagenContainer,
  ImagenContainerCiclos,
  CardMaterialCiclos,
  ImagenContainerManualCiclos,
} from '../components/Elements';
const componentImporter = (type) => {
  switch (type) {
    case 'ExternalTitle':
      return ExternalTitle;
    case 'CardRowMaterial':
      return CardRowMaterial;
    case 'TriggerLine':
      return TriggerLine;
    case 'CardMaterial':
      return CardMaterial;
    case 'MainHeader':
      return MainHeader;
    case 'TextCardMaterial':
      return TextCardMaterial;
    case 'Banner':
      return Banner;
    case 'CarrouselMaterial':
      return CarrouselMaterial;
    case 'TitleCard':
      return TitleCard;
    case 'TitleCardPDF':
      return TitleCardPDF;
    case 'TextCardMaterial':
      return TextCardMaterial;
    case 'Text':
      return Text;
    case 'Faq':
      return Faq;
    case 'FileManagerComponent':
      return FileManagerComponent;
    case 'BlankSpace':
      return BlankSpace;
    case 'HeaderSubtitle':
      return HeaderSubtitle;
    case 'TextMaterial':
      return TextMaterial;
    case 'ImagenContainerHome':
      return ImagenContainerHome;
    case 'ImagenContainer':
      return ImagenContainer;
    case 'ImagenContainerCiclos':
      return ImagenContainerCiclos;
    case 'CardMaterialCiclos':
      return CardMaterialCiclos;
    case 'ImagenContainerManualCiclos':
      return ImagenContainerManualCiclos;
    default:
      return null;
  }
};
export default componentImporter;
